import React from 'react';
import Button from '../../Input/Button/Button';

export const GenericButton = ({ text }) => (
    <span className="text text-generic">{text}</span>
);

export const RegisterButton = ({ onClick }) => (
    <Button
        type="solid"
        value="Register"
        class="default-btn"
        inputStyle="btn-input"
        onClick={onClick}
    />
);

export const RegisterRegisterToJoinButton = ({ onClick }) => (
    <Button
        type="solid"
        value="Register to Join"
        class="default-btn"
        inputStyle="btn-input"
        onClick={onClick}
    />
);

export const JoinLiveEventButton = ({ onClick }) => (
    <Button
        type="solid"
        value="Join live event"
        class="default-btn"
        inputStyle="btn-input"
        onClick={onClick}
    />
);

// no onClick - the surrounding calendar menu opens on click
export const AddToCalendarListButton = () => (
    <Button
        type="solid"
        value="Add to Calendar"
        class="default-btn add-to-calendar-btn"
        inputStyle="btn-input"
    />
);

export const InProgressButton = ({ isSingleEventPage, url }) => (
    <a
        className={`text text-purple ${
            isSingleEventPage ? 'text-registered' : ''
        }`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
    >
        {isSingleEventPage ? 'Go to event' : 'In progress: join now'}
    </a>
);

export const RegistrationClosedButton = () => (
    <GenericButton text="Registration closed" />
);

export const EventOverButton = () => <GenericButton text="Event is over" />;
